<template>
  <div class="">
    <div :style="dropdownStyle" class="text-sm mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
      <div class="p-2 border-b border-gray-200">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search..."
          class="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-dark"
        />
      </div>
      <div v-if="loading" class="flex justify-center p-4 items-center">
        <Spinning_Loader style="height: 100px; width:100px" />
      </div>
      <div v-else-if="options.length > 0" class="max-h-[180px] overflow-y-auto border-b border-gray-200">
        <ul class="py-1 text-gray-700">
          <li v-for="option in filteredPaginatedOptions" :key="option.id" class="px-4 py-1 hover:bg-gray-100 flex items-center gap-2">
            <input
              v-model="selectedOptions"
              type="checkbox"
              :value="option.id"
              @click.stop
            />
            <span>{{ option.name }}</span>
          </li>
          <li v-if="filteredPaginatedOptions.length === 0" class="px-4 py-2 text-gray-500 italic">
            No matching results
          </li>
        </ul>
      </div>
      <div v-else class="px-4 py-2 text-gray-500 italic">
        No options available
      </div>
      <div class="bg-gray-50">
        <div class="flex gap-2 justify-between items-center p-2 border-b border-gray-200">
          <button class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="selectAll">Select All</button>
          <button class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="selectNone">Select None</button>
        </div>
        <div v-if="shouldPaginate" class="flex justify-between items-center p-2 border-b border-gray-200">
          <button :disabled="currentPage === 1" class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="prevPage">Prev</button>
          <span>Page {{ currentPage }} of {{totalFilteredPages}}</span>
          <button :disabled="currentPage === totalFilteredPages" class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="nextPage">Next</button>
        </div>
        <div class="p-2">
          <button class="w-full hover:bg-gray-300 border border-gray-300 bg-gray-200 rounded p-1 mb-2" :disabled="applyDisabled || saving" @click="applyValue">
            <template v-if="saving">
              <font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" />Saving...
            </template>
            <template v-else>Apply</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinning_Loader from '@/components/widgetcomponents/Viz_Elements/Spinning_Loader.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {Spinning_Loader, FontAwesomeIcon},
  props: {
    options: {
      type: Array,
      required: true
    },
    initial: {
      type: Array,
      default: () => [],
    },
    applyDisabled: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
emits: ['submit'],
  data() {
    return {
      selectedOptions: this.initial || [],
      dropdownStyle: {},
      currentPage: 1,
      itemsPerPage: 20,
      searchQuery:''
    }
  },
  computed: {
    filteredOptions() {
      let opts = this.options;
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        opts = opts.filter(option => option.name.toLowerCase().includes(query));
      }
      return opts.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredPaginatedOptions() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredOptions.slice(start, end);
    },
    totalFilteredPages() {
      return Math.ceil(this.filteredOptions.length / this.itemsPerPage);
    },
    shouldPaginate() {
      return this.options.length > this.itemsPerPage
    },
  },
  watch: {
    searchQuery() {
      // Reset to first page when search query changes
      this.currentPage = 1;
    }
  },
  methods: {
    applyValue() {
      if (this.applyDisabled) return;
      this.$emit('submit', this.selectedOptions);
    },
    nextPage() {
      if (this.currentPage < this.totalFilteredPages) {this.currentPage++}
    },
    prevPage() {
      if (this.currentPage > 1) {this.currentPage--}
    },
    selectAll() {
      this.selectedOptions = this.filteredOptions.map(option => option.id);
    },
    selectNone() {
      this.selectedOptions = []
    },
  },
}
</script>
